<!-- 驼铃杯 -->
<template>
    <div class="cup">
        <div class="top flex-align">
            <img src="../assets/cup/cup.png" alt="">
            <div class="text flex-column">
                <span>第二届“驼铃杯”课堂教学大赛</span>
                <p>为贯彻党的二十大和党的二十届三中全会精神，落实《关于深化京蒙教育东西部协作工作的协议》任务要求，由北京市教育委员会和内蒙古自治区教育厅共同主办、
                    呼和浩特市教育局和首都师范大学承办、首都师范大学“双优云桥”项目组协办的第二届“驼铃杯”课堂教学大赛，将于2024年8月23日正式启动。
                    大赛旨在搭建京蒙两地教师交流平台，加强骨干教师队伍建设，展示京蒙教育协作最新教研和教学成果。</p>
            </div>
        </div>
        <div class="content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="活动首页" name="first">
                    <div class="activityHome">
                        <div class="title flex-align-center">大赛简介</div>
                        <div class="item flex-align">
                            <div class="icon"></div>
                            主题
                        </div>
                        <div class="wrap">弘扬爱国主义精神和铸牢中华民族共同体意识融合学科教学</div>
                        <div class="item flex-align">
                            <div class="icon"></div>
                            主办、承办、协办单位和平台支持
                        </div>
                        <div class="wrap">
                            <div class="danwei">
                                <div class="items">主办单位：北京市教育委员会、内蒙古自治区教育厅</div>
                                <div class="items">承办单位：呼和浩特市教育局、首都师范大学</div>
                                <div class="items">协办单位：首都师范大学“双优云桥”项目组</div>
                                <div class="items">平台支持：京蒙教育协作智慧平台</div>
                            </div>
                        </div>
                        <div class="item flex-align">
                            <div class="icon"></div>
                            大赛时间
                        </div>
                        <div class="wrap">2024年8月23日至10月31日</div>
                        <div class="item flex-align">
                            <div class="icon"></div>
                            参赛内容
                        </div>
                        <div class="wrap">
                            <div class="danwei">
                                <div class="items">1.参赛对象：本次大赛面向京蒙两地普通中小学所有学段语文和思想政治（道德与法治）教师。</div>
                                <div class="items">2.参赛作品主题：参赛作品要以“弘扬爱国主义精神和铸牢中华民族共同体意识融合学科教学”为主线，
                                    体现出对“双减”及新课标理念的落实，注重数字技术的应用与评价方式的创新，促进学生全面发展、健康成长。参赛作品须符合相应学段学科课程标准要求，具体作品可从教师任教科目中自行选择。
                                </div>
                                <div class="items">3.参赛作品要求：（1）须为本人原创；（2）未公开发布过；（3）未参加过其他各类比赛、专门为本次大赛创作的作品。</div>
                                <div class="items">
                                    4.参赛作品数量：大赛按学段学科分为小学语文组、小学道德与法治组、初中语文组、初中道德与法治组、高中语文组、高中思想政治组6个组别。每所学校单个组别提交作品数量不得超过1个，不接受跨校组队。
                                </div>
                            </div>
                        </div>
                        <!-- <div class="item flex-align">
                            <div class="icon"></div>
                            参赛对象
                        </div>
                        <div class="wrap">本次赛课选手主要由受援方内蒙古自治区乌兰察布市 的国家乡村振兴重点帮扶旗县和援助方的北京市平谷区、
                            丰 台区等青年骨干教师组成，涵盖高中语文、数学、英语、物 理、历史五个学科。参赛教师须经学校推荐，由赛事组委会 专家组遴选出80位入围比赛的选手，参加现场课堂教学比赛。
                        </div> -->
                        <div class="item flex-align">
                            <div class="icon"></div>
                            奖项设置
                        </div>
                        <div class="wrap">本次大赛设立一等奖、二等奖、三等奖以及优秀奖，大赛组委会最终将视比赛情况确定最终获奖比例和名单。
                            一等奖、二等奖、三等奖获奖人员颁发荣誉证书，荣誉证书由北京市教育委员会和内蒙古自治区教育厅联合印发。
                            <!-- <div class="danwei">
                                <div class="items">主办单位：乌兰察布市教育局</div>
                                <div class="items">指导单位：北京市教委支援合作处</div>
                                <div class="items">承办单位：北京双优云桥教育科技有限公司</div>
                                <div class="items">协办单位：商都县教育体育局</div>
                                <div class="items">平台支持：“首都教育远程互助工程”首都师范大学“双优云桥”智慧教育平台</div>
                            </div> -->
                        </div>
                        <div class="title flex-align-center">大赛流程</div>
                        <div class="liucheng flex-align-center">
                            <div class="flex-align">
                                <div class="liuchengItem">
                                    <div class="liuchengContent flex-column">
                                        <span>线上报名</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2024.08.23-09.08</div>
                                    </div>
                                </div>
                                <div class="liuchengItem2">
                                    <div class="liuchengContent flex-column">
                                        <span>提交参赛作品</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2024.09.09-09.18</div>
                                    </div>
                                </div>
                                <div class="liuchengItem3">
                                    <div class="liuchengContent flex-column">
                                        <span>大赛初审</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2024.09.19-09.26</div>
                                    </div>
                                </div>
                                <div class="liuchengItem4">
                                    <div class="liuchengContent flex-column">
                                        <span>大赛复审</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2024.09.29-10.15</div>
                                    </div>
                                </div>
                                <div class="liuchengItem5">
                                    <div class="liuchengContent flex-column">
                                        <span>现场展示</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2024.10下旬</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="more" @click="checkToken">上传作品</div>
                        <div class="title flex-align-center" @click="goCup">往期回顾</div>
                        <!-- <div class="title flex-align-center">课程展示</div>
                        <div class="courseBox flex-between">
                            <div class="courseItem flex-column-between" v-for="(item,index) in courseList" :key="index"
                                @click="goLive(item.video)">
                                <img :src="downloadURLImg+item.cover" alt="" v-if="item.cover">
                                <img src="../assets/course/course-cover05.jpg" alt="" v-else>
                                <span class="course_name">{{item.name}}</span>
                                <span class="name">{{item.teacherName}}</span>
                            </div>
                        </div>
                        <div class="more" @click="more">更多</div> -->
                    </div>
                </el-tab-pane>
                <el-tab-pane label="精彩回顾" name="second">
                    <el-empty description="暂未开放"></el-empty>
                    <!-- <div class="huigu">
                        <div class="video">
                            <video src="../assets/images/01.mp4" controls></video>
                        </div>
                        <div class="plan">
                            <img src="../assets/cup/table.png" alt="">
                        </div>
                    </div> -->
                </el-tab-pane>
                <el-tab-pane label="研训成果" name="third">
                    <el-empty description="暂未开放"></el-empty>
                    <!-- <div class="result">
                        <div class="box" v-for="(item,index) in list" :key="index">
                            <div class="item">
                                <span class="title">{{ item.title }}</span>
                                <div class="introduce">{{ item.introduce }}</div>
                                <div class="tag">
                                    标签
                                    <span>#{{item.mark}}#</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </el-tab-pane>
            </el-tabs>
        </div>
        <Login3 v-if="showLogin" :logoType="logoType" @getUserinfo="getUserinfo" @hideLogin="hideLogin"></Login3>
    </div>
</template>
<script>
import { EventBus } from './eventBus';
export default {
    data() {
        return {
            activeName: 'first',
            courseList: [],
            courseId: null,
            showLogin: false,
            list: [],
            cupInfo: {
                flowList: []
            },
            logoType: '',
            userName:''
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        goLive(url) {
            let query = {
                url
            }
            this.$router.push({ path: '/home/courseDetail2', query })
        },
        // goLive(id) {
        //     this.courseId = id;
        //     window.open(
        //             `https://jm.cnuen.net/login?un=18131405634&pd=Syyq123456@&origin=jm&courseId=${this.courseId}&projectId=266&goPath=course&keyCode=d63becec70f41c0ae20bca40e81f81dc&captchaCode=rgdzf`
        //             //  `http://localhost:8081/login?un=${this.pwdForm.username}&pd=${this.pwdForm.password}&origin=jm&courseId=${this.courseId}&goPath=course&keyCode=d63becec70f41c0ae20bca40e81f81dc&captchaCode=rgdzf`
        //         );
        // },
        getList() {
            let data = {
                page: 1,
                limit: 100,
                matchId: this.cupInfo.id
            };
            Api.Home.Result(data)
                .then(res => {
                    // console.log('研训成果:', res);
                    this.list = res.data.records
                })
                .catch(err => {
                    console.log('err:', err)
                })
        },
        getCupInfo() {
            Api.Home.cupInfo()
                .then(res => {
                    // console.log('驼铃杯信息:', res);
                    this.cupInfo = res.data;
                    this.getList();
                    this.getCourseList()
                })
                .catch(err => {
                    console.log('err:', err)
                })
        },
        more() {
            this.$router.push('/home/courseMore')
        },
        getCourseList() {
            let data = {
                matchId: this.cupInfo.id,
                page: 1,
                limit: 3,
            }
            Api.Home.listActivity(data)
                .then(res => {
                    console.log('专题活动:', res);
                    this.courseList = res.data.records;
                })
                .catch(err => {
                    console.log('专题活动失败:', err)
                })
        },
        goCup() {
            this.$router.push('/home/cup')
        },
        upload() {
            // window.open("https://cdnyun.cnuen.net/login")
        },
        // 判断token是否有效
        async checkToken() {
            let resData = await Api.Login.userInfo();
            console.log('获取个人信息2', resData);
            if (resData.code == 401) {
                this.showLogin = true;
                this.$store.commit('isDisplayLogin', true);
                return
            } else {
                this.userName = resData.data.name;
                if (this.logoType == '空中课堂') {
                    // 跳转空中课堂
                    this.getUrlCode(resData.data.phone, resData.data.id)
                } else {
                    // 跳转京蒙研修
                    let access_token = sessionStorage.getItem('token');
                    let member = sessionStorage.getItem('member')
                    window.open(`https://jm.cnuen.net/login?origin=cnueb&access_token=${access_token}&member=${member}`)
                }
            }
        },
        // 获取用户信息
        getUserinfo() {
            EventBus.$emit('test', 'Hello from ComponentA')
        },
        // async getUserinfo() {
        //     let resData = await Api.Login.userInfo();
        //     // console.log('获取个人信息1', resData);
        //     if (JSON.stringify(resData.data) == '{}') {
        //         this.$message.error('获取个人信息失败，请联系管理员');
        //         return;
        //     }
        //     if (resData.code == 401) {
        //         // this.$message.error(resData.msg);
        //         return
        //     }
        //     this.userName = resData.data.name;
        // },
        // 隐藏login
        hideLogin() {
            console.log('隐藏登录弹窗')
            this.isLogin = false
        }
    },
    mounted() {
        this.getCupInfo();
        // this.getCourseList()
    },
};
</script>
<style lang='less' scoped>
@import url("./less/cup2.less");
</style>